<template>
  <div
    class="dsf-monaco-editor-custom"
    ref="edit"
    :style="style"
  ></div>
</template>
<script>
const monacoLoader = require("_platform/editor/loader.js");

import {
  monacoRegisterLanguage,
  completionItemProviderForLocal,
  completionItemProviderForJupyter,
  hoverProvider,
  disposeAllProviders,
} from "./monacoConfig";
export default {
  name: "DsfMonacoCustom",
  props: {
    language: {
      type: String,
      default: "python",
    },
    editText: {
      type: String,
      default: "",
    },
    width: {
      type: [String, Number],
      default: "100%",
    },
    height: {
      type: [String, Number],
      default: "100%",
    },
    theme: {
      type: String,
      default: "vs",
    },
    // 自动提示内容
    // 格式：
    //  [{ name: "接口根",
    //     value: "root",
    //     type: "Module",
    //     detail: "根节点",
    //     children: []
    //   }]
    completionItems: {
      type: Array,
      default: () => [],
    },
    // 编辑器配置项
    // 配置项参考地址 https://microsoft.github.io/monaco-editor/api/interfaces/monaco.editor.IEditorOptions.html
    config: {
      type: Object,
      default: () => ({}),
    },
    // 加载提示功能
    loadTip: {
      type: Object,
      default: () => ({
        type: "local", // 支持local/jupyter 两种方式
        isOpenTip: false, // 是否开启提示
        localLanguage: [], // 本地支持语言
        jupyterLanguage: [], // jupyter支持语言
      }),
    },
    // 自定义提示
    loadTipCustom: {
      type: Function,
      default: null,
    },
    // 选中后回调
    suggestionSelectCallBack: {
      type: Function,
      default: null,
    },
    loadHover: {
      type: Object,
      default: () => ({
        isOpen: false,
        hoverCb: dsf.noop,
        language: [], // 支持语言
      }),
    },
    // loadLocalTip.type为jupyter时，须传入
    jupyterWs: {
      type: Object,
      default: () => null,
    },
    model: {
      type: String,
      default: "",
    },
  },
  computed: {
    style() {
      const { width, height } = this;
      const fixedWidth =
        width.toString().indexOf("%") !== -1 ? width : `${width}px`;
      const fixedHeight =
        height.toString().indexOf("%") !== -1 ? height : `${height}px`;
      return {
        width: fixedWidth,
        height: fixedHeight,
      };
    },
  },
  watch: {
    config: {
      handler(val) {
        if (this.editerInstance) {
          this.editerInstance.updateOptions(val);
        }
      },
      deep: true,
    },
    // editText(val) {
    //   if (this.editerInstance) {
    //     this.editerInstance.setValue(val);
    //   }
    // },
    width(v) {
      this.updateLayout();
    },
    height() {
      this.updateLayout();
    },
    completionItems(val, old) {
      let newVal = JSON.stringify(val);
      let oldVal = JSON.stringify(old);
      if (this.editerInstance) {
        if (newVal !== oldVal) {
          if (this.loadTip.isOpenTip) {
            this.handleLoadCodeTip(val);
          }
        }
      }
      this.completionItemCeche = val;
    },
    jupyterWs: {
      handler(val) {
        if (val && this.editerInstance && this.loadJupyterTip) {
          this.handleOpenCodeTip();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    monacoLoader.load("", this.createdEditer);
    window.addEventListener("resize", this.updateLayout);
  },
  data() {
    return {
      languageMapping: {
        python: "customPython",
      },
      editerInstance: null,
      editModels: {},
      completionItemCeche: [],
      suggestionCommand: null, // 接受suggestion选中后的回调
    };
  },
  methods: {
    // 创建编辑器
    createdEditer() {
      let editDom = this.$refs.edit;
      // 注册python语言
      monacoRegisterLanguage("customPython");
      // 新建模型
      let { model } = this.createModel(this.model || dsf.uuid(), this.language);
      if (!model) {
        return;
      }
      this.editerInstance = window.monaco.editor.create(editDom, {
        model: model,
        theme: this.theme,
        ...this.config,
      });
      // 添加快捷键 ctrl+s
      this.editerInstance.addCommand(
        monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_S,
        () => {
          const code = this.editerInstance.getValue();
          this.$emit("editorSave", code);
        }
      );
      // 添加快捷键alt+f8
      this.editerInstance.addCommand(monaco.KeyCode.F8, () => {
        const code = this.editerInstance
          .getModel()
          .getValueInRange(this.editerInstance.getSelection());
        this.$emit("runcode", code);
      });
      if (this.suggestionSelectCallBack) {
        this.suggestionCommand = window.monaco.editor.registerCommand(
          "editor.suggest",
          (accessor, ...args) => {
            this.suggestionSelectCallBack(args);
          }
        );
      }

      // 焦点失去后，保存代码
      // this.editerInstance.onDidBlurEditorText((e) => {
      //   const code = this.editerInstance.getValue();
      //   this.$emit("editorSave", code);
      // });
      // 监听值改变
      let _this = this;
      const changeValue = _.throttle(({ changes }) => {
        let value = _this.editerInstance.getValue();
        _this.$emit("changeValue", { changes, value });
      }, 50);
      this.editerInstance.onDidChangeModelContent(changeValue);
      // 初始化完成
      this.$emit("editLoaded", this.editerInstance);
      // ==================== 加载提示信息 ====================
      if (this.loadTip.isOpenTip) {
        this.handleLoadCodeTip();
      }
      if (this.loadHover.isOpen) {
        this.handleLoadHoverTip();
      }
    },
    // 加载hover提示
    handleLoadHoverTip() {
      const langs = _.map(this.loadHover.language, this.getRealLanguage);
      hoverProvider(langs, this.loadHover.hoverCb);
    },
    // 加载代码提示
    handleLoadCodeTip(val) {
      if (this.loadTip.type === "local") {
        const langs = _.map(this.loadTip.localLanguage, this.getRealLanguage);
        completionItemProviderForLocal(
          val || this.completionItemCeche,
          langs,
          this.loadTipCustom
        );
      } else {
        const langs = _.map(this.loadTip.jupyterLanguage, this.getRealLanguage);
        completionItemProviderForJupyter(this.jupyterWs, langs);
      }
    },
    /**
     * @description: 创建monacoModel
     * @param {String} modelId modelId
     * @param {String} lang 语言类型
     * @param {String} code model内容
     * @result: monaco Model
     */
    createModel(modelId, lang, code) {
      let realLang = this.getRealLanguage(lang);
      let realCode = dsf.isUnDef(code) ? this.editText : code;
      if (this.editModels[modelId]?.model) {
        return this.editModels[modelId];
      } else {
        let model = window.monaco.editor.createModel(realCode, realLang);
        this.editModels[modelId] = {
          model,
          viewState: null, // 视图状态
        };
        return { model };
      }
    },
    // 更换语种
    changeLang(lang, modelId) {
      let model = this.editModels[modelId]?.model;
      let realLang = this.getRealLanguage(lang);
      if (model) {
        window.monaco.editor.setModelLanguage(model, realLang);
      }
    },
    // 更换Model
    changeModel(modelId, prevModelId) {
      let prevModel = this.editModels[prevModelId];
      // 保存视图状态
      if (prevModel) {
        let viewState = this.editerInstance.saveViewState();
        prevModel.viewState = viewState;
      }
      let model = this.editModels[modelId];
      if (model.model) {
        this.editerInstance.setModel(model.model);
        model.viewState &&
          this.editerInstance.restoreViewState(model.viewState);
      } else {
        dsf.layer.message("编辑器不存在该Model", false);
      }
    },
    // 新增model
    addModel(modelId, lang, code, prevModelId) {
      let prevModel = this.editModels[prevModelId];
      // 保存视图状态
      if (prevModel) {
        let viewState = this.editerInstance.saveViewState();
        prevModel.viewState = viewState;
      }
      let { model, viewState } = this.createModel(modelId, lang, code);
      if (model) {
        this.editerInstance.setModel(model);
        viewState && this.editerInstance.restoreViewState(viewState);
        this.$nextTick(() => {
          this.editerInstance.layout();
        });
      }
    },
    // 删除model
    delModel(modelId) {
      let model = this.editModels[modelId]?.model;
      if (model) {
        model.dispose();
        setTimeout(() => {
          delete this.editModels[modelId];
        }, 50);
      }
    },
    getRealLanguage(lang) {
      return this.languageMapping[lang] || lang;
    },
    getValue() {
      return this.editerInstance.getValue();
    },
    /**
     * @description: 添加代码
     * @param {string} code 代码串
     * @param {string} type 添加方式  [focus, end]
     * @return {*}
     */
    addCode(code, type = "focus") {
      if (!dsf.isString(code)) {
        dsf.layer.message("插入内容须为字符串");
        return;
      }
      if (this.editerInstance) {
        let range = null;
        if (type === "focus") {
          let selection = this.editerInstance.getSelection();
          range = new monaco.Range(
            selection.startLineNumber,
            selection.startColumn,
            selection.endLineNumber,
            selection.endColumn
          );
        } else {
          const maxLine = this.editerInstance.getModel().getLineCount();
          range = new monaco.Range(maxLine + 1, 1, maxLine + 1, 1);
        }
        let op = {
          range: range,
          text: code,
          forceMoveMarkers: true, // 取消选中状态
        };
        this.editerInstance.executeEdits("", [op]);
        this.editerInstance.focus();
      }
    },
    // 更新编辑器布局
    updateLayout() {
      if (this.editerInstance) {
        this.editerInstance.layout();
      }
    },
    setValue(content) {
      this.editerInstance.setValue(content);
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateLayout);
    disposeAllProviders();
    for (let key in this.editModels) {
      this.editModels[key]?.dispose?.();
    }
    if (this.editerInstance) {
      this.editerInstance?.dispose?.();
    }
    this.suggestionCommand?.dispose?.();
  },
};
</script>